import { colones } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SelectorPlantillaDialog = ({ open, onOpenChange, plantillas, onSelect }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-white max-w-lg">
      <DialogHeader><DialogTitle>Cargar plantilla de reparación</DialogTitle></DialogHeader>
      <div className="space-y-1 max-h-80 overflow-y-auto">
        {plantillas.length === 0 && <p className="text-sm text-muted-foreground">No hay plantillas creadas.</p>}
        {plantillas.map((p) => (
          <button key={p.id} data-testid={`seleccionar-plantilla-${p.id}`}
            className="w-full text-left border border-border rounded-sm px-3 py-2 hover:bg-secondary"
            onClick={() => onSelect(p.id)}>
            <div className="font-medium text-sm">{p.nombre}</div>
            <div className="text-xs text-muted-foreground">
              {p.items.length} repuestos · Mano de obra: {colones(p.mano_de_obra)}
              {p.modelos?.length > 0 && ` · ${p.modelos.map((m) => m.modelo).join(", ")}`}
            </div>
          </button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
